export default "__VITE_ASSET__9bcd56ae__"